<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  props: {
    crumbs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
});
</script>
<template>
  <div class="bu-level cly-breadcrumbs bu-mb-5">
    <div
      v-for="(crumb, index) in crumbs"
      :key="index"
      :class="[&quot;bu-level-item text-medium bu-mr-0&quot;,
               {&quot;bu-ml-2&quot;: (index !== 0)},
               {&quot;color-cool-gray-40&quot;: (index === (crumbs.length - 1))}]"
    >
      <a :href="crumb.url">{{ crumb.label }}</a>
      <span
        v-if="index !== (crumbs.length - 1)"
        class="bu-ml-2"
      >></span>
    </div>
  </div>
</template>
